import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthChecker = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const auth = localStorage.getItem('auth');
    const isLoginPath = location.pathname === '/';
    
    if (auth && isLoginPath) {
      navigate('/home');
    }
    setAuthChecked(true); // Set authChecked to true after checking
  }, [navigate, location.pathname]);

  if (!authChecked) {
    return null; // Render nothing until auth check is done
  }

  return children;
};

export default AuthChecker;
